// 统一开关：关闭后恢复仅悬浮/选中显示单位名称，街道光晕不受缩放门槛限制。
export const MAP_LABEL_LAYOUT_ENABLED = true;

const LABEL_GAP = 10;
const PANEL_SELECTOR = '.monitor_wrap, .monitor-header, .monitor-top, .monitor-bfooter';

function intersects (a, b, gap = 0) {
  return a.left < b.right + gap && a.right > b.left - gap &&
    a.top < b.bottom + gap && a.bottom > b.top - gap;
}

// 仅管理主监控地图自动名称：缩放门槛、屏幕空间避让及独立覆盖物生命周期。
export default {
  data () {
    return {
      labelLayoutEnabled: MAP_LABEL_LAYOUT_ENABLED,
      labelOverviewZoom: 15,
      autoUnitLabels: [],
      autoLabelTimer: null,
      labelPanelObserver: null,
      labelLayoutMoving: false
    };
  },
  watch: {
    labelLayoutEnabled () {
      this.clearAutoUnitLabels();
      this.scheduleAutoUnitLabels();
      this.scheduleBaihedongUpdate();
    }
  },
  mounted () {
    const screen = this.$el.closest('.monitor');
    // 面板显隐和入场动画完成后重排，避免按动画中间位置留下被遮挡的名称。
    this.labelPanelObserver = new MutationObserver(this.scheduleAutoUnitLabels);
    screen.querySelectorAll(PANEL_SELECTOR).forEach(panel => {
      this.labelPanelObserver.observe(panel, { attributes: true, attributeFilter: ['class', 'style'] });
    });
    screen.addEventListener('animationend', this.scheduleAutoUnitLabels, true);
    screen.addEventListener('transitionend', this.scheduleAutoUnitLabels, true);
  },
  beforeDestroy () {
    this.labelPanelObserver.disconnect();
    const screen = this.$el.closest('.monitor');
    screen.removeEventListener('animationend', this.scheduleAutoUnitLabels, true);
    screen.removeEventListener('transitionend', this.scheduleAutoUnitLabels, true);
    this.clearAutoUnitLabels();
  },
  methods: {
    isLabelOverviewVisible () {
      return !this.labelLayoutEnabled || this.map.getZoom() >= this.labelOverviewZoom;
    },
    // 移动期间保持已有标签随地图移动，结束后再计算避让，避免不断换位。
    pauseAutoUnitLabels () {
      this.labelLayoutMoving = true;
      clearTimeout(this.autoLabelTimer);
      this.autoLabelTimer = null;
    },
    finishAutoUnitLabels () {
      this.labelLayoutMoving = false;
      if (!this.isLabelOverviewVisible()) this.clearAutoUnitLabels();
      this.scheduleAutoUnitLabels();
    },
    scheduleAutoUnitLabels () {
      clearTimeout(this.autoLabelTimer);
      this.autoLabelTimer = null;
      if (!this.isMapReady() || this.labelLayoutMoving || this._isBeingDestroyed) return;
      this.autoLabelTimer = setTimeout(() => {
        this.autoLabelTimer = null;
        this.updateAutoUnitLabels();
      }, 120);
    },
    clearAutoUnitLabels () {
      clearTimeout(this.autoLabelTimer);
      this.autoLabelTimer = null;
      this.autoUnitLabels.forEach(entry => this.map && this.map.removeLayer(entry.layer));
      this.autoUnitLabels = [];
    },
    // 交互标签立即取得优先级，同一单位不同时显示自动名称与悬浮名称。
    suppressAutoUnitLabel (code) {
      this.autoUnitLabels = this.autoUnitLabels.filter(entry => {
        if (entry.key !== String(code)) return true;
        this.map.removeLayer(entry.layer);
        return false;
      });
      this.scheduleAutoUnitLabels();
    },
    updateAutoUnitLabels () {
      if (!this.isMapReady()) return;
      if (!this.labelLayoutEnabled || !this.isLabelOverviewVisible()) {
        this.clearAutoUnitLabels();
        return;
      }
      const container = this.$refs.mapContainer;
      const bounds = container.getBoundingClientRect();
      const size = this.map.getSize();
      if (!bounds.width || !bounds.height) return;
      // 大屏可能通过 CSS 缩放，统一换算成地图内部像素，避免测量和投影口径不一致。
      const scaleX = size.x / bounds.width;
      const scaleY = size.y / bounds.height;
      const readRect = element => {
        if (!element || !element.getClientRects().length) return null;
        const rect = element.getBoundingClientRect();
        if (!rect.width || !rect.height || getComputedStyle(element).visibility === 'hidden') return null;
        return {
          left: (rect.left - bounds.left) * scaleX,
          right: (rect.right - bounds.left) * scaleX,
          top: (rect.top - bounds.top) * scaleY,
          bottom: (rect.bottom - bounds.top) * scaleY
        };
      };
      const viewport = { left: 0, top: 0, right: size.x, bottom: size.y };
      const panels = Array.from(container.closest('.monitor').querySelectorAll(PANEL_SELECTOR))
        .map(readRect).filter(Boolean);
      // 微消站独立于单位刷新，但图标和资料标签仍参与单位名称避让。
      const stationLayers = this.fireStationLayers.flatMap(entry => [entry.marker, entry.label]);
      const occupied = [...this.markerLayers, ...stationLayers].map(layer => readRect(layer.getElement && layer.getElement()))
        .filter(rect => rect && intersects(rect, viewport));
      if (this.baihedongOverviewLabel) {
        const rect = readRect(this.baihedongOverviewLabel.getElement());
        if (rect) occupied.push(rect);
      }
      const previous = new Map(this.autoUnitLabels.map(entry => [entry.key, entry]));
      const candidates = this.markerLayers.filter(marker => marker.hm_marker &&
        marker.hm_mouseover !== 'none' && !this.titleMarker.includes(marker) &&
        marker !== this.titleSourceMarker && marker.hm_data.code !== this.currentDw && marker.hm_data.name)
        .map(marker => ({ marker, key: String(marker.hm_data.code) }))
        .sort((a, b) => Number(previous.has(b.key)) - Number(previous.has(a.key)));
      const measure = document.createElement('span');
      measure.className = 'tianditu-auto-unit-label';
      measure.style.visibility = 'hidden';
      container.appendChild(measure);
      const next = [];
      try {
        candidates.forEach(({ marker, key }) => {
          const icon = readRect(marker.getElement());
          if (!icon || !intersects(icon, viewport) || panels.some(panel => intersects(icon, panel))) return;
          const name = String(marker.hm_data.name);
          const text = name.length > 12 ? `${name.slice(0, 12)}…` : name;
          measure.textContent = text;
          const measured = measure.getBoundingClientRect();
          const width = measured.width * scaleX;
          const height = measured.height * scaleY;
          const x = (icon.left + icon.right) / 2;
          const y = (icon.top + icon.bottom) / 2;
          const positions = {
            top: [x - width / 2, icon.top - LABEL_GAP - height],
            bottom: [x - width / 2, icon.bottom + LABEL_GAP],
            right: [icon.right + LABEL_GAP, y - height / 2],
            left: [icon.left - LABEL_GAP - width, y - height / 2]
          };
          const old = previous.get(key);
          const sides = [...new Set([old && old.side, 'top', 'bottom', 'right', 'left'].filter(Boolean))];
          for (const side of sides) {
            const [left, top] = positions[side];
            const rect = { left, top, right: left + width, bottom: top + height };
            if (left < LABEL_GAP || top < LABEL_GAP || rect.right > size.x - LABEL_GAP ||
              rect.bottom > size.y - LABEL_GAP || panels.some(panel => intersects(rect, panel, LABEL_GAP)) ||
              occupied.some(other => intersects(rect, other, LABEL_GAP))) continue;
            const point = this.getMapPoint(marker.hm_data);
            const pixel = this.map.lngLatToContainerPoint(point);
            const offset = this.getTiandituLabelOffset(left - pixel.x, top - pixel.y);
            const layer = old ? old.layer : new window.T.Label({
              // textContent 转义业务名称，避免标签 HTML 将单位名称解释为标记。
              text: measure.innerHTML, position: point, offset, className: 'tianditu-auto-unit-label'
            });
            if (old) {
              layer.setLabel(measure.innerHTML);
              layer.setLngLat(point);
              layer.setOffset(offset);
            } else this.map.addLayer(layer);
            occupied.push(rect);
            next.push({ key, layer, side });
            break;
          }
        });
      } finally {
        measure.remove();
      }
      const retained = new Set(next.map(entry => entry.layer));
      this.autoUnitLabels.forEach(entry => {
        if (!retained.has(entry.layer)) this.map.removeLayer(entry.layer);
      });
      this.autoUnitLabels = next;
    }
  }
};
